// Explicit synthetic preview data. Never used as component defaults.
import { ART_BASE } from '../assets.js';
const ASSET = ART_BASE;

export const FIXTURE_SCENE_CHIPS = [
  { label: 'Level 4 village', tone: 'violet' },
  { label: '112 family quests', tone: 'gold' },
  { label: '4-week streak', tone: 'ember' },
];

export const FIXTURE_SCENE_GLINTS = [
  { label: 'Maya · 7:31', x: 24, y: 48, delay: 0 },
  { label: 'Leo · 6:55', x: 58, y: 40, delay: 1.2 },
  { label: 'Finn · 5:20', x: 78, y: 58, delay: 2.1 },
];

export const FIXTURE_PROJECT = {
  eyebrow: 'Village project · this week',
  title: 'Light 30 lanterns together',
  value: 21,
  goal: 30,
  unit: 'lanterns',
  deadline: 'the chapter closes Friday at the Payday Festival',
  contributors: [
    { id: 'maya', name: 'Maya', count: 9, src: `${ASSET}/avatar-kid-1.jpg`, alt: 'Maya' },
    { id: 'leo', name: 'Leo', count: 8, src: `${ASSET}/avatar-kid-2.jpg`, alt: 'Leo' },
    { id: 'finn', name: 'Finn', count: 4, src: `${ASSET}/avatar-kid-3.jpg`, alt: 'Finn' },
  ],
  rewardName: 'Festival Stage',
  rewardOutcome: 'rises in the square — for keeps.',
};

export const FIXTURE_PRESENCE = [
  {
    id: 'leo-lantern',
    name: 'Leo',
    avatar: `${ASSET}/avatar-kid-2.jpg`,
    avatarAlt: 'Leo',
    what: 'Leo lit a lantern ✦',
    when: '2 minutes ago',
    live: true,
  },
  {
    id: 'maya-kitchen',
    name: 'Maya',
    avatar: `${ASSET}/avatar-kid-1.jpg`,
    avatarAlt: 'Maya',
    what: 'You lit the Kitchen Lantern',
    when: 'today at 4:12 — Dad high-fived!',
  },
  {
    id: 'finn-biscuit',
    name: 'Finn',
    avatar: `${ASSET}/avatar-kid-3.jpg`,
    avatarAlt: 'Finn',
    what: 'Finn fed Biscuit by the fountain',
    when: 'this morning',
  },
];

export const FIXTURE_BUILDINGS = [
  {
    id: 'bakery',
    name: 'Bakery',
    stat: "Unlocked at 100 family quests — it smells like Tuesday's cookies.",
    color: 'oklch(.62 .12 60)',
    status: 'built',
    title: 'Bakery — unlocked at 100 family quests',
  },
  {
    id: 'bridge',
    name: 'Bridge',
    stat: 'Built on your 4-week family streak — it crosses the river for good.',
    color: 'oklch(.62 .11 220)',
    status: 'built',
    title: 'Bridge — built on your 4-week streak',
  },
  {
    id: 'fountain',
    name: 'Fountain',
    stat: 'Started flowing when your family jars reached $25 saved together.',
    color: 'oklch(.74 .09 220)',
    status: 'built',
    title: 'Fountain — flowed when the family jars reached $25',
  },
  {
    id: 'clock-tower',
    name: 'Clock Tower',
    stat: 'Still a quiet outline — it rings at 250 family quests. 138 to go, no hurry.',
    status: 'locked',
    title: 'Clock Tower — rings at 250 family quests',
  },
];

export const FIXTURE_ROADMAP = {
  title: 'Coming soon: villages beyond the hill',
  description:
    "One day you'll spot other families' lights on the horizon — friendly villages to wave to, never " +
    "strangers, never a race. We're still laying the road, so for now the hill keeps its secret.",
  chipLabel: 'on the roadmap · not built yet',
};

export const villageFixture = {
  sceneChips: FIXTURE_SCENE_CHIPS,
  sceneGlints: FIXTURE_SCENE_GLINTS,
  project: FIXTURE_PROJECT,
  presence: FIXTURE_PRESENCE,
  buildings: FIXTURE_BUILDINGS,
  roadmap: FIXTURE_ROADMAP,
  kidName: 'Maya',
  streak: 4,
  avatar: `${ASSET}/avatar-kid-1.jpg`,
};
